// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11 0.856049L21 6.41161V9.00001H1V6.41161L11 0.856049ZM6 11V19H4V11H6ZM12 11V19H10V11H12ZM18 11V17H16V11H18ZM22.5961 17.9394L16.9392 23.5963L13.4037 20.0608L14.8179 18.6466L16.9392 20.7679L21.1819 16.5252L22.5961 17.9394ZM1 21H12V23H1V21Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-institution-checked-filled')
export default class InstitutionCheckedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'institution-checked-filled',
    }
  }
}
